
  <div class="scroll-wrap">
    <div class="choice-wrap">
      <h1 class="title">{{ data?.title }}</h1>
      <img @load="scrollRefresh" class="title-img" v-if="data.url" :src="data.url" alt="">
        <ul
          class="list-wrap"
        >
          <li
            v-for="(item, index) in data?.optionVoList"
            @click="handleOptionClick(item)"
            :key="item.optionKey"
            :name="item.optionKey"
            :class="{ selected: item.select }"
          >
            <div v-if="item?.isUrl === 1" class="img-item" >
              <p>{{ String.fromCharCode(65 + index) }}.</p>
              <img @load="scrollRefresh " :src="item.content" alt="">
            </div>
            <div v-else class="list-item">
              {{ item.content }}
            </div>
          </li>
        </ul>
    </div>
  </div>
